import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    activo: false,
    data: {},
    fc_09: {
        aduanasalida: "",
        calle: "",
        codigopostal: "",
        colonia: "",
        correoelectronico: "",
        delegacionmunicipio: "",
        domicilio: "",
        emicioncertificadonomexportacion: false,
        emicioncertificadonomexportacionparapromocion: false,
        entregahologramas: false,
        estado: "",
        fechasolicitud: "2022-02-23",
        fechavisitapropuesta: "2022-02-23",
        inspeccionenvasadoparaexportaci: false,
        localidad: "",
        nombre: "",
        numerocliente: 0,
        numeroexterior: 0,
        numerointerior: 0,
        observaciones: "",
        paisdestino: "",
        resposableinstalaciones: "",
        telefono: "",
    },
    loading: false,
    productos: {},
    paginaActiva: 1,
    fc_09Map: [],
    productosMap: [],
    modoProceso: false,
    modoRecibidasCorregidas: false,
    modoVerDetalle: false,
    filesMap: [],
    filesProductosMap: []
}

//types
const ACTUALIZAR_FC_09_PAGINA = 'ACTUALIZAR_FC_09_PAGINA'
const ACTUALIZAR_FC_09_ESTATUS_EXITO = 'ACTUALIZAR_FC_09_ESTATUS_EXITO'
const AGREGAR_FC_09_EXITO_MAP = 'AGREGAR_FC_09_EXITO_MAP'
const AGREGAR_ANEXO_FC_09_EXITO_MAP = 'AGREGAR_ANEXO_FC_09_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_09_MAP_EXITO = 'OBTENER_FC_09_MAP_EXITO'
const OBTENER_DETALLE_FC_09_EXITO = 'OBTENER_DETALLE_FC_09_EXITO'
const OBTENER_DETALLE_FC_09_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_09_CON_MAPS_EXITO'
//AGREGADO POR YU
const AGREGAR_FC_09_EXITO = 'OBTENER_FC_09_EXITO'
const AGREGAR_FC_09_MAP_EXITO = 'AGREGAR_FC_09_MAP_EXITO'

const ACEPTAR_SOLICITUD_EXITO = 'ACEPTAR_SOLICITUD_EXITO'
const GENERAR_OFICIOS_EXITO = 'GENERAR_OFICIOS_EXITO'
const ACTUALIZAR_FC_09_EXITO = 'ACTUALIZAR_FC_09_EXITO'
const AGREGAR_FC_09_FORMULARIO_EXITO = 'AGREGAR_FC_09_FORMULARIO_EXITO'

export const obtenerSolicitudDetalleFC_09 = createAsyncThunk(
    OBTENER_DETALLE_FC_09_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerSolicitudDetalleFC_09ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_09_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFC_09Estatus = createAsyncThunk(
    ACTUALIZAR_FC_09_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarMapFC_09Accion = createAsyncThunk(
    AGREGAR_FC_09_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud[0] }
            let productosMap = data.productosMap
            let documentacion = data.archivosPrincipalMap
            let archivosProductosMap = data.archivosProductosMap
            delete solicitud.idfc09_solicitudcertificadomap

            const agregarFC_09Map = host + `MapSolicitud/agregarMapFC_09_Solicitud`
            const agregarAnexosProductosMap = host + 'MapSolicitud/agregarMapFC_09_AnexoProducto'
            const agregarFC_09ArchivosMap = host + `MapSolicitud/agregarMapFC_09_ArchivosGenerales`
            const agregarFC_09ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_09_ArchivosProductos`

            const res = await axios.post(agregarFC_09Map, solicitud)

            for (const anexo of productosMap) {
                delete anexo.idfc09_anexoproductomap
                await axios.post(agregarAnexosProductosMap, { data: anexo })
            }
            for (const anexo of documentacion) {
                delete anexo.idfc09_archivomap
                await axios.post(agregarFC_09ArchivosMap, { data: anexo })
            }
            for (const anexo of archivosProductosMap) {
                delete anexo.idfc09_archivoproductomap
                await axios.post(agregarFC_09ArchivosproductosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_09Solicitud = createAsyncThunk(
    AGREGAR_FC_09_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosParaActualizar = data.archivosPrincipal
            const archivosParaActualizarProductos = data.archivosProductos
            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`
            // const urlActualizarAnexoProductos = host + 'FC_09/actualizarFormatoFC09_AnexoProducto' 
            const urlActualizarAnexoArchivos = host + 'FC_09/actualizarArchivoFC09'
            const urlActualizarArchivosProductos = host + 'FC_09/actualizarArchivoProductoFC_09'
            const res = await axios.put(actualizarFC_09, solicitud)

            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado

            for (const anexo in archivosParaActualizar) {
                let resAnexo = await axios.put(urlActualizarAnexoArchivos, { data: archivosParaActualizar[anexo] })
            }

            for (const anexo in archivosParaActualizarProductos) {
                let resAnexo = await axios.put(urlActualizarArchivosProductos, { data: archivosParaActualizarProductos[anexo] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_09SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_09_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const idfc09_solicitudcertificadomap = data.idfc09_solicitudcertificadomap
            const productosParaActualizar = data.productosMap
            const archivosPrincipalMap = data.archivosPrincipalMap
            const archivosProductosMap = data.archivosProductosMap
            const agregarFC_09ArchivosMap = host + `MapSolicitud/agregarMapFC_09_ArchivosGenerales`
            const agregarFC_09ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_09_ArchivosProductos`

            const actualizarFC_09Map = host + `MapSolicitud/actualizarMapFC_09_Solicitud`
            const urlActualizarAnexoProductos = host + 'MapSolicitud/actualizarMapFC_09_AnexoProducto'
            const urlActualizarArchivosGenerales = host + 'MapSolicitud/actualizarMapFC_09_ArchivosGenerales'
            const urlActualizarArchivosproductos = host + 'MapSolicitud/actualizarMapFC_09_ArchivosProductos'
            solicitud.data[0].idfc09_solicitudcertificadomap = idfc09_solicitudcertificadomap
            const res = await axios.put(actualizarFC_09Map, solicitud)

            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado

            for (let anexo of productosParaActualizar) {
                let resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
            }
            for (let anexo of archivosPrincipalMap) {
                if (anexo.idfc09_archivomap != "" && anexo.idfc09_archivomap != null && anexo.idfc09_archivomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivosGenerales, { data: anexo })
                } else {
                    delete anexo.idfc09_archivomap
                    let resAnexo = await axios.post(agregarFC_09ArchivosMap, { data: anexo })
                }

            }
            for (let anexo of archivosProductosMap) {
                if (anexo.idfc09_archivoproductomap != "" && anexo.idfc09_archivoproductomap != null && anexo.idfc09_archivoproductomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivosproductos, { data: anexo })
                } else {
                    delete anexo.idfc09_archivoproductomap
                    let resAnexo = await axios.post(agregarFC_09ArchivosproductosMap, { data: anexo })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const obtenerFC_09Map = createAsyncThunk(
    OBTENER_FC_09_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_09_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            const Map = await obtenerProductosMap(solicitudId)
            productosMap.push(Map.anexoProductoMap)
            mapFiles.push(Map.filesGeneralMap)
            filesProductosMap.push(Map.filesProductosMap)

            const solicitudMap = {
                data: res.data.data,
                mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_09_AnexoProducto/`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_09_ArchivosGenerales/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_09_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_09archivos
        const filesProductos = res.data.data.fc_09_anexoproducto
        const filesGeneralMap = []
        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_09archivos)

            if(resfiles.data.data){
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_09archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }

        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_09archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_09archivoproducto)

                if(resfiles.data.data){
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_09archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            } 
        }
        // const filesProductos = res.data.data
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_09_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc09_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let Map = { anexoProductoMap: anexoProductoMap, filesGeneralMap: filesGeneralMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}


export const aceptarSolicitudFC_09 = createAsyncThunk(
    ACEPTAR_SOLICITUD_EXITO,
    async (data) => {
        try {

            const { dataImportadores, productos } = data
            const urlAgregarImportadoresCliente = host + 'InformacionValida/agregarImportadoresCliente'
            const urlAgregarProductosCliente = host + 'InformacionValida/agregarProductosCliente'
            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'

            const resImporatadores = await axios.post(urlAgregarImportadoresCliente, { data: dataImportadores })

            for (let i in productos) {
                const { idfc09_anexoproducto, idfc09_solicitudcertificado, fc_09archivoproducto, ...anexo } = productos[i]
                anexo.idcliente = dataImportadores.idcliente
                anexo.idtipoproductos = 1
                const resProducto = await axios.post(urlAgregarProductosCliente, { data: anexo })
                const idproductocliente = resProducto.data.data.idproductocliente
                for (const j in fc_09archivoproducto) {
                    const { idfc_09archivoproducto, idfc09_anexoproducto, fc_09archivoproductomap, ...restFile } = fc_09archivoproducto[j]
                    restFile.nombreTabla = 'archivoproductocliente'
                    restFile.nameFK = 'idproductocliente'
                    restFile.idFK = idproductocliente
                    restFile.observaciones = fc_09archivoproductomap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }

            return resImporatadores
        } catch (error) {
            console.log(error);
        }
    }
)

export const generarDocumentosFC_09 = createAsyncThunk(
    GENERAR_OFICIOS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_09Formulario = createAsyncThunk(
    AGREGAR_FC_09_FORMULARIO_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }
            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`
            const res = await axios.put(actualizarFC_09, solicitud)
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const fc09Slice = createSlice({
    name: 'fc09Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_09(state, { payload }) {
            state.paginaActiva = payload
        },
        resetDataFC_09(state, { payload }) {
            return dataInicial
        },
        guardarCambiosFC_09Solicitud(state, { payload }) {
            state.fc_09 = payload
        },
        agregarFC_09AnexoProducto(state, { payload }) {
            state.productos = payload
        },
        setModoVerDetalleFC_09(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoProcesoFC_09(state, { payload }) {
            state.modoProceso = payload
        },
        setModoRecibidasCorregidasFC_09(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
    },
    extraReducers: {
        [agregarMapFC_09Accion.fulfilled]: (state, { payload }) => {
        },
        // [agregarMapAnexosFC_09Accion.fulfilled]: (state, {payload}) => {  
        // },
        [actualizarFC_09Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_09Map.fulfilled]: (state, { payload }) => {
            state.fc_09Map = payload.data
            state.productosMap = payload.productosMap[0]
            state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
        },
        [obtenerSolicitudDetalleFC_09.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [actualizarFC_09Solicitud.fulfilled]: (state, { payload }) => {
        },
        [aceptarSolicitudFC_09.fulfilled]: (state, { payload }) => {
        },
        [generarDocumentosFC_09.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_09SolicitudMap.fulfilled]: (state, { payload }) => {
        },
        [obtenerSolicitudDetalleFC_09ConMaps.fulfilled]: (state, { payload }) => {
        },
    },
})

//METODOS QUE SE AÑADEN PARA ACTUALIZAR EL FORMATO PRINCIPAL  por yu


//METODOS QUE SE AÑADEN PARA ACTUALIZAR TODOS LOS CHECKS por yu

export const actualizarFC_09MapSolicitud = createAsyncThunk(
    AGREGAR_FC_09_MAP_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const certificadosParaActualizar = { data: data.certificadosParaActualizar }

            const actualizarFC_09 = host + `MapSolicitud/actualizarMapFC_09_Solicitud`
            const urlActualizarAnexoProductos = host + 'MapSolicitud/agregarMapFC_09_AnexoProducto'

            const res = await axios.put(actualizarFC_09, solicitud)

            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado

            for (let anexo of certificadosParaActualizar.data) {
                let resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

//actions
export const {
    actualizarPaginaActivaFC_09,
    resetDataFC_09, guardarCambiosFC_09Solicitud,
    agregarFC_09AnexoProducto, setModoVerDetalleFC_09,
    setModoProcesoFC_09, setModoRecibidasCorregidasFC_09
} = fc09Slice.actions

export const FC09ReducerAtencionACliente = fc09Slice.reducer